import React from 'react';

export default function Battery({
  allFeelings,
  feeling,
  setFeelings,
  setClicked,
  clicked,
}) {
  const handleClicFeeling = (services) => {
    setClicked(true);
    setFeelings(() => services);
  };
  return (
    <div className="b-container">
      <div className="fc-c">
        <div className="fc-h"></div>
        <div className="fc-m" style={{ borderColor: '#e4f2f4' }}>
          {allFeelings?.map((service) => (
            <div
              style={{
                backgroundColor:
                  clicked && feeling === service.name
                    ? service.color
                    : clicked && feeling !== service.name
                    ? 'gray'
                    : !clicked && feeling !== service.name && service.color,
                color:
                  service.name === 'Ok' && feeling !== 'Ok' ? '#ffff' : '#ffff',
              }}
              key={service?.id}
              onClick={() => handleClicFeeling(service?.name)}
              className="sslistitem item-m-f"
            >
              

              {service?.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
